<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="card-header mt-4">
      <h1>Create New Schedule</h1>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <label for="League">Leauge</label>
          <span class="error" v-if="!league && !isInputValid">* field required</span>
          <base-input alternative v-model="league" @input="onInputChanged()" />
        </div>
        <div class="col-md-12">
          <label for="Home">Home</label>
          <span class="error" v-if="!home && !isInputValid">* field required</span>
          <v-select v-model="home" :options="allClubName"></v-select>
        </div>
        <div class="col-md-12 mt-4">
          <label for="Away">Away</label>
          <span class="error" v-if="!away && !isInputValid">* field required</span>
          <v-select v-model="away" :options="allClubName"></v-select>
        </div>
        <div class="col-md-12 mt-4">
          <label for="DateTime">Date Time</label>
          <date-picker v-model="date" :config="options"></date-picker>
        </div>
        <div class="col-md-12 text-center mt-6">
          <base-button
            type="primary"
            :disabled="isLoading"
            @click="onCreateClicked()"
          >{{schedule ? 'Update Schedule' : 'Create Schedule'}}</base-button>
        </div>
        <div class="col-md-12 text-center mt-5 mb-4" v-if="error">
          <span class="response-error">* {{ error.message }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'

import store from '@/store'

import {
  GET_CLUBS,
  CREATE_LIVE_SCHEDULE,
  GET_SCHEDULE,
  UPDATE_SCHEDULE
} from '@/store/actions.type'
import { mapState } from 'vuex'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      league: '',
      home: '',
      away: '',
      date: new Date(),
      options: {
        format: 'YYYY-MM-DD hh:mm A',
        useCurrent: false,
        showClear: true,
        showClose: true
      },
      isInputValid: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.dispatch(GET_SCHEDULE, to.params.id).then(() => next())
    } else {
      next()
    }
  },
  created() {
    this.$store.dispatch(GET_CLUBS)
    if (this.schedule) {
      this.league = this.schedule.league
      this.home = this.schedule.home.clubName
      this.away = this.schedule.away.clubName
      let date = new Date(this.schedule.startedAt)
      let startedAt = `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDay()} ${date.getHours()}:${date.getMinutes()}`
      this.date = startedAt
    }
  },
  destroyed() {
    this.$store.state.schedule.schedule = null
  },
  methods: {
    onCreateClicked() {
      if (this.league && this.home && this.away) {
        if (this.home === this.away) {
          this.$store.state.schedule.error = {
            message: 'Home and Away cannot be the same!'
          }
          return
        }
        let homeClub = this.clubs.filter(club => club.clubName === this.home)[0]
        let awayClub = this.clubs.filter(club => club.clubName === this.away)[0]

        let startedAt = this.date
        if (!(this.date instanceof Date)) {
          startedAt = new Date(startedAt)
        }

        let schedule = {
          league: this.league,
          startedAt: startedAt.toUTCString(),
          homeClubId: homeClub.id,
          awayClubId: awayClub.id
        }
        if (this.schedule) {
          schedule.id = this.schedule.id
          this.$store.dispatch(UPDATE_SCHEDULE, schedule).then(() => {
            this.$router.push({ name: 'schedule' })
          })
        } else {
          this.$store.dispatch(CREATE_LIVE_SCHEDULE, schedule).then(() => {
            this.$router.push({ name: 'schedule' })
          })
        }
      } else {
        this.isInputValid = false
      }
    },
    onInputChanged() {
      this.$store.state.schedule.error = null
    }
  },
  computed: {
    ...mapState({
      schedule: state => state.schedule.schedule,
      clubs: state => state.schedule.clubs,
      isLoading: state => state.schedule.isLoading,
      error: state => state.schedule.error
    }),
    allClubName() {
      let clubs = []
      for (var i in this.clubs) {
        clubs.push(this.clubs[i].clubName)
      }
      return clubs
    }
  }
}
</script>
<style scoped>
.error {
  color: #fb6340 !important;
  font-size: 14px;
  float: right;
}
</style>>
